<script setup lang="ts">
import { VButton } from '@shared/component/VButton';
import VCallToAction from '@shared/component/VCallToAction/VCallToAction.vue';
import VContentBox from '@shared/component/VContentBox/VContentBox.vue';
import VInfoBox from '@shared/component/VInfoBox/VInfoBox.vue';
import VPageContainer from '@shared/layout/VPageContainer/VPageContainer.vue';
import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

import { toRefs } from 'vue';
import RelatieGegevensLopendeActiviteit, {
  type Item,
} from './RelatieGegevensLopendeActiviteit.vue';

const props = defineProps<{
  relatienummer: number;
}>();

const { relatienummer } = toRefs(props);

const { data, isPending } = useQuery({
  queryKey: ['lopendeOffertes', relatienummer.value],
  queryFn: () =>
    axios.get<Array<Item>>(`/net/relation/GetQuotations`, {
      params: { relationNumber: relatienummer.value, json: true },
    }),
});
</script>

<template>
  <VPageContainer container-size="sm" title="Offertes">
    <VInfoBox type="danger" v-if="!isPending && data?.status !== 200">
      Er is een onbekende fout opgetreden. Probeer het later opnieuw.
    </VInfoBox>
    <RelatieGegevensLopendeActiviteit :items="data?.data" :loading="isPending" />
    <VButton
      prepend-icon="far fa-plus"
      v-if="data?.data.length"
      class="mb-4 mt-4"
      :href="`/app/offerte/offertes/nieuw/?relatienummer=${relatienummer}`"
    >
      Nieuwe offerte
    </VButton>
    <VContentBox v-if="!isPending && data?.data.length === 0">
      <VCallToAction
        class="py-16"
        title="Er zijn momenteel geen lopende offertes voor deze relatie."
        icon="far fa-calculator"
      >
        <VButton
          prepend-icon="far fa-plus"
          :href="`/app/offerte/offertes/nieuw/?relatienummer=${relatienummer}`"
        >
          Nieuwe offerte
        </VButton>
      </VCallToAction>
    </VContentBox>
  </VPageContainer>
</template>
